module.exports = __webpack_public_path__ + "static/media/bb-logo-big.a00bd055.png";